module.exports = __webpack_public_path__ + "static/media/estj.adefb9e4.png";